<template>
  <section class="container">
    <section class="title_box">
      <img src="../assets/images/act_success.png" />
      <p>{{title}}!</p>
    </section>
    <p class="desc">{{desc}}</p>
    <p class="back_btn submit_btn" @click="backFun">返回</p>
  </section>
</template>

<script>
export default {
  props:{
    come:{
      type:String,
      default:''
    }
  },
  data () {
    return {
      title:'发送成功',
      desc:'已成功发送至电子邮箱，请注意查收~'
    }
  },
  created () {
    document.title = this.$route.query.title || '';
    this.title = this.$route.query.title || '';
    this.desc = this.$route.query.desc || '';
  },
  methods: {
    backFun(){
      if(this.come === 'parkingCoupon'){
        this.$store.commit('isChange', true);
        this.$router.go(-2)
      }else{
        this.$router.go(-1)
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import "../assets/css/common.less";
.container{
  background:#fff;
}
.title_box{
  .flex();
  justify-content:center;
  align-items:center;
  margin:120px 0 28px;
  img{
    width:44px;
    height:44px;
    margin-right:14px;
  }
  p{
    font-size:48px;
    color:#333;
    line-height:66px;
  }
}
.desc{
  text-align:center;
  font-size:28px;
  color:rgba(153,153,153,1);
  line-height:40px;
  margin-bottom:114px;
}
.back_btn{
  background:@color17;
  margin:0 74px;
  border-radius:4px;
  height:76px;
  text-align:center;
  line-height:76px;
  font-size:32px;
  color:#fff;
}
</style>
